import { Account } from '@/app/network/models/v1/account';
import { Dropdown, DropdownButton, DropdownItem, DropdownMenu } from '@/common/components/dropdown';
import { ChevronDownIcon } from '@/icons/fa/regular';
import { getAccountLabel } from '@/shared/accounts';

type AccountPickerProps = {
  accounts: Account[];
  selectedAccount?: Account;
  onSelectAccount: (account: Account) => void;
};

export function AccountPicker({ accounts, selectedAccount, onSelectAccount }: AccountPickerProps) {
  return (
    <Dropdown>
      <DropdownButton outline>
        {getAccountLabel(selectedAccount) ?? 'Select an account'}
        <ChevronDownIcon />
      </DropdownButton>
      <DropdownMenu>
        {accounts.map(account => (
          <DropdownItem
            key={account.account_number}
            onClick={() => onSelectAccount(account)}
          >
            {getAccountLabel(account)}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
